import { render, staticRenderFns } from "./EntertainView.vue?vue&type=template&id=2c34baea"
import script from "./EntertainView.vue?vue&type=script&lang=js"
export * from "./EntertainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports